import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=2ec2d040&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
import style0 from "./Button.vue?vue&type=style&index=0&id=2ec2d040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2d040",
  null
  
)

export default component.exports